<app-modal
  #saveModal
  [modalVariant]="modalVariant.Secondary"
  (modalClose)="closeModal()"
>
  <ng-container modal-header>
    {{ translateKey('title') }}
  </ng-container>

  <p modal-content>
    {{ translateKey('content') }}
  </p>

  <div modal-footer>
    <button
      app-vtmn-play-button
      type="button"
      [type]="ctaButtonType.Button"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [shape]="vtmnPlayButtonShape.SQUARED"
      (click)="updateTimeslot.emit()"
      class="modal__edit__timeslots__footer__button"
    >
      {{ translateKey('button.only_this_timeslot') }}
    </button>

    <button
      *ngIf="!isLastTimeslot"
      app-vtmn-play-button
      type="button"
      [type]="ctaButtonType.Button"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [shape]="vtmnPlayButtonShape.SQUARED"
      (click)="updateSelectedTimeslots.emit()"
      class="modal__edit__timeslots__footer__button"
    >
      {{ translateKey('button.select_timeslots') }}
    </button>

    <button
      *ngIf="!isLastTimeslot"
      app-vtmn-play-button
      type="button"
      [type]="ctaButtonType.Button"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [shape]="vtmnPlayButtonShape.SQUARED"
      (click)="updateAllTimeslots.emit()"
      class="modal__edit__timeslots__footer__button modal__edit__timeslots__footer__button--last"
    >
      {{ translateKey('button.next_timeslots') }}
    </button>
  </div>
</app-modal>
